// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__LodPS","slider__disabled":"Slider_slider__disabled__lJgud"};